export const RoutePaths = {
  //HOME: "/",
  HOME: "/dashboard-frame",
  SEGMENTTIERSETTING: "/segment-tier-setting",
  CREATESEGMENTTIERSETTING: "/create-segment-tier-setting",
  EDITSEGMENTTIERSETTING: "/edit-segment-tier-setting",
  COMBINATIONRFM: "/rfm-combination-frame",
  //COMBINATIONRFM: "/rfm-combination",
  CREATECOMBINATIONRFM: "/create-rfm-combination",
  //IFRAMECOMBINATIONRFM: "/rfm-combination-frame",
  IFRAMECOMBINATIONRFM: "/rfm-combination",
  //IFRAMEHOME: "/dashboard-frame",
  IFRAMEHOME: "/",

  IFRAMERFMPROFILE: "/rfm-profile",
  RFMPROFILE: "/rfm-profile-frame",

  IFRAMECREATERFMPROFILE: "/create-rfm-profile",
  CREATERFMPROFILE: "/create-rfm-profile-frame",

  IFRAMEEDITRFMPROFILE: "/edit-rfm-profile",
  EDITRFMPROFILE: "/edit-rfm-profile-frame",

  IFRAMEVIEWRFMPROFILE: "/view-rfm-profile",
  VIEWRFMPROFILE: "/view-rfm-profile-frame",

  IFRAME_TARGET_MARKETING_HOME: "/target-marketing",
  TARGET_MARKETING_HOME: "/target-marketing-frame",

  IFRAME_TARGET_MARKETING_ALL: "/target-marketing-all",
  TARGET_MARKETING_ALL: "/target-marketing-all-frame",

  IFRAME_CREATE_CAMPAIGN: "/create-campaign",
  CREATE_CAMPAIGN: "/create-campaign-frame",

  IFRAME_UPDATE_CAMPAIGN: "/update-campaign",
  UPDATE_CAMPAIGN: "/update-campaign-frame",

  IFRAME_DETAIL_CAMPAIGN: "/detail-campaign",
  DETAIL_CAMPAIGN: "/detail-campaign-frame",

  IFRAME_MESSAGE_TEMPLATES: "/message-templates",
  MESSAGE_TEMPLATES: "/message-templates-frame",

  IFRAME_CREATE_MESSAGE_TEMPLATES: "/create-message-templates",
  CREATE_MESSAGE_TEMPLATES: "/create-message-templates-frame",
};
